import { createFileRoute } from '@tanstack/react-router';
import { TransferCard } from '@/components/transfer/transfer-card';

export const Route = createFileRoute('/')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div className="min-h-svh grid place-items-center p-4">
      <TransferCard />
    </div>
  );
}
